import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/esm/Dropdown";

import {
    Nav, 
    Navbar, 
    NavDropdown, 
    Container,
    Modal,
    Button
} from "react-bootstrap";

import { ProfileContent } from './ProfileContent';

export const AppHeader = (props) => {
 
    const navigate = useNavigate();

    const isAuthenticated = useIsAuthenticated();
    const { instance, accounts } = useMsal();
    const handleLogout = () => {
        instance.logoutRedirect({
            postLogoutRedirectUri: "/",
        });
    }
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <> 
        {isAuthenticated &&
            <Navbar bg="light" expand='lg'>
                <Container fluid>
                    <Navbar.Brand href="/">
                        <img src="/idb-invest-logo.svg" style={{height:'2.5rem'}}/>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="navbarScroll" />
                    <Navbar.Collapse id="navbarScroll" className="justify-content-start">
                        <Nav>
                            <NavDropdown title="Projects" id="projects-nav-dropdown" className="mr-3">
                                <NavDropdown.Item onClick={()=>navigate("/projects/new")}>New Report</NavDropdown.Item>
                                <NavDropdown.Item onClick={()=>navigate("/projects/reports")}>Reports</NavDropdown.Item>
                            </NavDropdown>
                            
                            <NavDropdown title="Templates" id="tempaltes-nav-dropdown" className="mr-3">
                                <NavDropdown.Item href="/Docs/Crops_Input_Form.xlsx">Crops</NavDropdown.Item>
                                <NavDropdown.Item href="/Docs/Facilities_Input_Form.xlsx">Facilities</NavDropdown.Item>
                                <NavDropdown.Item href="/Docs/Livestock_Input_Form.xlsx">Livestock</NavDropdown.Item>
                                <NavDropdown.Item href="/Docs/Transportation_Input_Form.xlsx">Transportation</NavDropdown.Item>
                                <NavDropdown.Divider />
                            </NavDropdown>

                            <Nav.Link href="/Docs/agriadapt-user-manual.pdf" target="_blank">User Manual</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                    <DropdownButton variant="outline-success" className="ml-auto" drop="down" title={accounts[0]?.username}>
                    <Dropdown.Item as="button" onClick={handleShow}>Profile</Dropdown.Item>
                        <Dropdown.Item as="button" onClick={() => handleLogout()}>Sign out</Dropdown.Item>
                    </DropdownButton>
                </Container>
            </Navbar>
        }
        
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Profile</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ProfileContent />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Close</Button>
            </Modal.Footer>
        </Modal>
        </>
    );
};